import { useState, useEffect } from 'react';
import { AuthService } from '../services/auth.service';
import { InstitutionService } from '../services/institution.service';
import { UserType } from '../interfaces/userType.enum';

interface Institution {
    id: string;
    name: string;
}

export const usePayrollInstitution = () => {
    const user = AuthService.getCurrentUser();
    const isSystemAdmin = user?.roles?.includes(UserType.SystemAdmin) ?? false;

    const [institutions, setInstitutions] = useState<Institution[]>([]);
    const [institutionId, setInstitutionId] = useState<string>(
        isSystemAdmin ? '' : (AuthService.getSelectedInstitution() || '')
    );

    useEffect(() => {
        if (!isSystemAdmin) return;
        InstitutionService.getInstitutions(0, 1000).then((data) => {
            setInstitutions(data.content || []);
        }).catch(() => {});
    }, [isSystemAdmin]);

    return { isSystemAdmin, institutions, institutionId, setInstitutionId };
};